const msg001 = ''
const updateFail = '更新に失敗しました。<br/>入力内容を確認してください。'
const updateFailPassword = '更新に失敗しました。<br/>パスワードが誤っています。'
const updateSuccess = '更新が完了しました。'
const updateEmailSuccess = '変更後メールアドレスに メールをお送りしました。'
const duplicateMail = '更新に失敗しました。<br/> 変更後のメールアドレスが使用されている可能性があります。入力内容を確認してください。'
const loginErr = "入力したメールアドレスもしくはパスワードが間違っ ています。<br/>パスワードをお忘れの場合は、<a class='text--underline' href='/reset-password'>こちら</a>からパスワード をリセットしてください。"
const confirmErr = 'パスワードが正しくありません。'
const signupErr = "ご指定のメールアドレスは既に登録されております。 <br>パスワードをお忘れの場合は、<a class='text--underline' href='/reset-password'>こちら</a>からパスワード をリセットしてください。"
const serverErr = 'サーバは処理中にエラーが発生しました。再度ご確認ください。'
const resetPassFail = 'ご指定のメールアドレスは登録されておりません。'
const acceptLicenseErr = '同意する前にライセンスをダウンロードしてください。'
const selectPlanWarn = 'プランを選択して下さい。'
const nameInvalidErr = '最初にご担当者を入力してください。'
const registerWarn = '個人情報の取り扱いに同意してください。'
const noInternet = 'リクエストの送信中にエラーが発生しました。再度お試しください。'
const emailNotActivate = 'このメールアドレスは本登録されていません。登録時にお送りした、メールをご確認ください。'
const amazonUpdateFail = '更新に失敗しました。<br/>・出品者ID/MWS認証トークンが間違っている可能性があります。<br/>・出品者IDは使用されている可能性があります。<br/>入力内容を確認してください。'
const exceptCountry = '一部の国または地域からはセールモンスターをご利用いただけません。<br/>なお、サービス対象外の国または地域は予告なく変更になる場合がございます。あらかじめご了承ください。'
const amazonThrottleError = 'ただいまAmazonへのアクセスが大変混み合っています。恐れ入りますが、しばらく時間をおいてから操作してください。'
const maintenance = 'システムメンテナンス中です'

export default {
  msg001,
  updateFail,
  updateFailPassword,
  updateSuccess,
  updateEmailSuccess,
  duplicateMail,
  loginErr,
  confirmErr,
  signupErr,
  serverErr,
  resetPassFail,
  acceptLicenseErr,
  selectPlanWarn,
  nameInvalidErr,
  registerWarn,
  noInternet,
  emailNotActivate,
  amazonUpdateFail,
  exceptCountry,
  amazonThrottleError,
  maintenance
}



// WEBPACK FOOTER //
// ./src/common/msg.js